import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export const getImages = (imageName) => {
  try {
      const image = require(`../../assets/images/${imageName}`);
      return image;
  } catch(err) {
      // return 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=';
      return 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  }
}
export default function ScrollToTop() {
    const { pathname } = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  
    return null;
  }
  

  const makeImages = require.context('../../assets/images/', false, /\.png$/);

export const getMakeImages = (imageMakeName) => {
  try {
    return makeImages(`./${imageMakeName}`);
  } catch (err) {
    // If image not found, return fallback
    return makeImages('./Mercedes-Showroom-logo.png');
 }
};